"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBuffer = void 0;
function isBuffer(value) {
    return (value != null &&
        value.constructor != null &&
        typeof value.constructor.isBuffer === "function" &&
        value.constructor.isBuffer(value));
}
exports.isBuffer = isBuffer;
